import { render } from "./ImprovementFormModal.vue?vue&type=template&id=16485834&ts=true"
import script from "./ImprovementFormModal.vue?vue&type=script&lang=ts"
export * from "./ImprovementFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__